
<div class="center" *ngIf="pointer">
  <div class="yaw">yaw: <strong>{{pointer.yaw | number : '0.1-1' }}</strong></div>
  <div class="yaw">pitc: <strong>{{pointer.pitch | number : '0.1-1' }}</strong></div>
  <div class="yaw">fov: <strong>{{pointer.fov | number : '0.1-1' }}</strong></div>
</div>
